import { DATE_FORMAT } from 'v2/core/date/date';
import { DateTimeRange, TimePeriodUnit } from './types';

export const INPUT_DATE_FORMAT = 'D/M/YYYY';
export const SUPPORTED_INPUT_DATE_FORMATS = [
  'DD-MM-YYYY',
  'D-M-YYYY',
  'YYYY-MM-DD',
  DATE_FORMAT,
];

export const DEFAULT_DATE_TIME_RANGE: DateTimeRange = {
  type: 'last',
  unit: TimePeriodUnit.Month,
  value: 3,
};

export const DATE_RANGE_CONJUNCTION = ' -> ';
